module.exports = __webpack_public_path__ + "img/swingVariabilityText8.92b6a025.png";